import { render, staticRenderFns } from "./CMServiceActivation.vue?vue&type=template&id=52b106af&"
import script from "./CMServiceActivation.vue?vue&type=script&lang=js&"
export * from "./CMServiceActivation.vue?vue&type=script&lang=js&"
import style0 from "./CMServiceActivation.vue?vue&type=style&index=0&id=52b106af&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52b106af')) {
      api.createRecord('52b106af', component.options)
    } else {
      api.reload('52b106af', component.options)
    }
    module.hot.accept("./CMServiceActivation.vue?vue&type=template&id=52b106af&", function () {
      api.rerender('52b106af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/popups/services/CMServiceActivation.vue"
export default component.exports